import './index.scss';
import { useForm } from 'react-hook-form';
import React, { useEffect, useState } from 'react';
import BookGymInfo from '../../pages/book-fitness/BookGymInfo';
import ModifyGymForm from '../../pages/book-fitness/ModifyGymForm/index';
import {
  getHourFromTimeStampOption,
  getSingleModifyOption,
} from '../../../utility/Utils';
import { useModalData } from '../../../store/modal/modalHooks';
import BookContainer from '../../shared/book-components/BookModalComponent/BookModalComponent';
import BookSuccessMessage from '../../pages/book-fitness/BookSuccessMessage';
import CancellationPolicy from '../../shared/cancellation-policy/CancellationPolicy';
import { MyActivityResourceImpl } from '../../../API/my-activities/implements/my-activity-resource.impl';

const ViewGymModal = () => {
  const modalData = useModalData();
  const activity: MyActivityResourceImpl = modalData?.data.activity;

  const [showSuccessPage, setShowSuccessPage] = useState(false);

  const [showCancellationPolicy, setShowCancellationPolicy] = useState(false);

  const defaultValues = {
    date: activity.alloc?.startTime
      ? new Date(activity.alloc?.startTime)
      : new Date(),
    start: getHourFromTimeStampOption(activity.alloc?.startTime),
    end: getHourFromTimeStampOption(activity.alloc?.endTime),
  };

  useEffect(() => {
    reset({
      date: activity.alloc?.startTime
        ? new Date(activity.alloc?.startTime)
        : new Date(),
      start: getHourFromTimeStampOption(activity.alloc?.startTime),
      end: getHourFromTimeStampOption(activity.alloc?.endTime),
    });

    const resetStartEndValues = () => {
      form.setValue(
        'start',
        getHourFromTimeStampOption(activity.alloc?.startTime)
      );
      form.setValue('end', getHourFromTimeStampOption(activity.alloc?.endTime));
    };
    setTimeout(resetStartEndValues, 0);
  }, [activity]);

  const form = useForm({ defaultValues });
  const {
    reset,
    formState: { errors },
  } = form;

  return (
    <div className="book-gym-modal">
      <BookContainer
        infoComponent={
          !showCancellationPolicy ? (
            <BookGymInfo gym={activity.resource!} form={form} />
          ) : (
            <CancellationPolicy policyId={activity.resource?.policyId} />
          )
        }
        formComponent={
          !showSuccessPage ? (
            <ModifyGymForm
              activityId={activity.alloc?.id!}
              activity={activity}
              form={form}
              gym={activity.resource!}
              setShowSuccessPage={setShowSuccessPage}
              setShowCancellationPolicy={setShowCancellationPolicy}
              showCancellationPolicy={showCancellationPolicy}
            />
          ) : (
            <BookSuccessMessage />
          )
        }
      />
    </div>
  );
};

export default ViewGymModal;
